import { render } from "./ModuleTable.vue?vue&type=template&id=008c654e"
import script from "./ModuleTable.vue?vue&type=script&lang=js"
export * from "./ModuleTable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__